// 전각 문자인지 검사
const checkIsZenkaku = (value) => {
  for (let i = 0; i < value.length; ++i) {
    const charCode = value.charCodeAt(i);
    if (charCode < 256 || (charCode >= 0xff61 && charCode <= 0xff9f)) {
      return false;
    }
  }
  return true;
};

export { checkIsZenkaku };
